import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";

import enHome from "./locales/en/home.json";
import ptHome from "./locales/pt/home.json";
import enCommon from "./locales/en/common.json";
import ptCommon from "./locales/pt/common.json";

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    fallbackLng: "pt",
    interpolation: { escapeValue: false },
    ns: ["common", "home", "navbar"],
    defaultNS: "common",
    resources: {
      en: {
        home: enHome,
        navbar: require("./locales/en/navbar.json"),
        personalityTypes: require("./locales/en/personalityTypes.json"),
        user: require("./locales/en/user.json"),
        common: enCommon,
      },
      pt: {
        home: ptHome,
        navbar: require("./locales/pt/navbar.json"),
        personalityTypes: require("./locales/pt/personalityTypes.json"),
        user: require("./locales/pt/user.json"),
        common: ptCommon,
      },
    },
    backend: {
      loadPath: "/locales/{{lng}}/{{ns}}.json",
    },
  });

export default i18n;
